/* eslint-disable no-nested-ternary */
import React, { RefObject, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { Container } from '../Container';

const pillars = [
  {
    title: 'PREPARE',
    description:
      "Empower your area before a crisis arrives.* When citizens verify themselves on Represent and activate their NFT Passport, they arm their communities with real-time readiness. Represent becomes a living defense grid—blockchain-backed, geo-gated, and ready to respond. Preparation isn’t just planning—it’s connecting every person into a unified civic voice, standing by at a moment’s notice. If you and your area are prepared, unauthorized foreign or domestic agenda's cannot be implemented.",
  },
  {
    title: 'PROTECTION',
    description:
      'Collective voice is the shield. Represent enables verified citizens to instantly unite and act when local rights, resources, or freedoms are threatened. Through geo-gated, on-chain voting, communities assert their will—not in months or years, but in minutes. Protection isn’t passive; it’s active, responsive, and always on. When every voice is verified and ready, no decision about your future can be made without your participation towards Majority Voice Protection.',
  },
  {
    title: 'PRESERVATION',
    description:
      'What’s sacred must be safeguarded. Represent empowers communities to defend the enduring—land, liberty, lineage, and legacy. Whether it’s ancestral territory, cultural traditions, natural resources, or inherited freedoms, the blockchain ledger ensures these rights are not forgotten, erased, or sold without consent. With Represent, your values, history, and voice are preserved in digital stone, immune to manipulation, and anchored by the will of the verified many.',
  },
  {
    title: 'PROSPERITY',
    description:
     'True prosperity flows from unity, integrity, and self-direction. Represent opens the gate to a future where economic growth, social well-being, and community innovation arise from self-governed systems. When people direct their own outcomes—free from imposed controls—they create thriving networks of trade, education, security, and opportunity. Whether rural or urban, local or global, Represent unlocks the tools to build wealth that’s earned, shared, and sustained.',
  },
];

type SectionKeyProps = {
  refSection: RefObject<HTMLDivElement>;
};

export function SectionInAdvantages({ refSection }: SectionKeyProps) {
  const section = useRef(null);
  const [activeIndex, setActiveIndex] = useState<number|null>(null);
  const isMobile = window.innerWidth < 1440;

  const handleClose = () => setActiveIndex(null);

  // eslint-disable-next-line consistent-return
  const getTranslate = (i:number) => {
    if (activeIndex === i) {
      if (isMobile) {
        return { transform: `translateY(-${i * 70}px)` };
      }
      return { transform: `translateY(${200 - i * 188}px)` };
    }
  };

  return (
    <section className={styles.containerKey} ref={section}>
      <Container>
        {activeIndex !== null && (
        <button className={styles.close} onClick={handleClose} type="button">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.22051 0.157655L7.99347 6.92698L14.6945 0.225617C15.1511 -0.181162 15.6238 0.0617067 15.8127 0.265596C15.9338 0.41325 15.9963 0.60038 15.9882 0.791213C15.9801 0.982046 15.9019 1.1632 15.7687 1.30003L9.06667 8.0004L15.7687 14.6988C16.0665 14.9486 16.0665 15.4384 15.8276 15.7122C15.5878 15.9851 15.1481 16.143 14.7335 15.8192L7.99347 9.07381L1.24549 15.8222C0.949711 16.087 0.462074 16.033 0.221253 15.7702C-0.0205668 15.5063 -0.112498 15.0506 0.196272 14.7287L6.92027 8.0004L0.224251 1.30003C-0.020567 1.03018 -0.105504 0.536449 0.224251 0.225617C0.554006 -0.0852138 1.04564 -0.042237 1.22051 0.157655Z"
              fill="#141311"
            />
          </svg>
        </button>
        )}

        <div ref={refSection} className={styles.keyAnchor} />
        <div className={styles.content}>
          <div className={styles.wrapper}>
            {pillars.map((pillar, i) => (
              <button
                type="button"
                key={pillar.title}
                className={`${styles.pillarItem} ${
                  activeIndex === i
                    ? styles.active
                    : activeIndex !== null
                      ? styles.hidden
                      : ''
                }`}
                onClick={() => {
                  setActiveIndex(i);
                  if (i === activeIndex) {
                    setActiveIndex(null);
                  }
                }}
                style={
                getTranslate(i)
}
              >
                <span>{pillar.title}</span>
              </button>
            ))}

            {activeIndex !== null && (
            <div className={styles.detail}>
              {pillars[activeIndex].title}
              {pillars[activeIndex].description}
            </div>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
}
